export const POST_CALENDAR_ROUTE = "/post-calendar";
export const CALENDAR_POST_SCREENS = ["scheduled", "published"] as const;
